import {InputErrorMessageComponent} from "./components/input-error-message.component";
import {InputSelect} from "./components/input-select";
import {InputText} from "./components/input-text";
import {AutofocusDirective} from "./autofocus.directive";
import {SepaFormComponent} from "./sepa-form/sepa-form.component";
import {ButtonSubmit} from "./components/button-submit";
import {ContactFormComponent} from "./contact-form/contact-form.component";
import {UserProfileFormComponent} from "./user-profile-form/user-profile-form.component";
import {InputCheckbox} from "./components/input-checkbox";
import {CompanyFormComponent} from "./company-form/company-form.component";
import {CustomerFormComponent} from "./customer-form/customer-form.component";
import {PartnerProfileFormComponent} from "./partner-profile-form/partner-profile-form.component";
import {PortNumberFormComponent} from "./port-number-form/port-number-form.component";
import {PortBlockNumberFormComponent} from "./port-block-number-form/port-block-number-form.component";
import {InputTextarea} from "./components/input-textarea";
import {SubscriptionReferenceFormComponent} from "./subscription-reference-form/subscription-reference-form.component";

export const formComponents = [
  InputErrorMessageComponent,
  ButtonSubmit,
  InputText,
  InputSelect,
  AutofocusDirective,
  SepaFormComponent,
  ContactFormComponent,
  UserProfileFormComponent,
  InputCheckbox,
  CompanyFormComponent,
  CustomerFormComponent,
  PartnerProfileFormComponent,
  PortNumberFormComponent,
  PortBlockNumberFormComponent,
  InputTextarea,
  SubscriptionReferenceFormComponent
]